export default __webpack_public_path__ + "static/media/register-v2-dark.2b051707.svg";